import { ApiError, ApiService } from "./api.service"
import { Constants } from "../constants"

class Status {
    constructor(status) {
        this.id = status ? status.id : undefined
        this.name = status ? status.name : undefined
    }
}

class StatusDropdown {
    constructor(status) {
        this.id = status ? status.id : undefined
        this.value = status ? status.name : undefined
        this.checked = false
    }
}

const StatusService = {

    getStatus: async function() {
        try {
            const endpoint = Constants.ENDPOINT_STATUS
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    }

}

export { StatusService, Status, StatusDropdown }